// @flow

import { useTranslator } from '@gandi/translate';

import type { AvailabilityIconName } from './Icon/IconContainer';

import {
  UnavailableErrorContainer,
  UnavailableRowContainer,
} from './UnavailableRowContainer';

type Props = {
  children: React.Node,
  availabilityIconName: AvailabilityIconName,
  availabilityText: string,
  fqdn: string,
};

export function Unavailable({
  availabilityIconName,
  availabilityText,
  fqdn,
  children,
}: Props): React.MixedElement {
  return (
    <UnavailableRowContainer
      availabilityIconName={availabilityIconName}
      availabilityText={availabilityText}
      fqdn={fqdn}
    >
      {children}
    </UnavailableRowContainer>
  );
}

Unavailable.Error = function UnavailableError({
  fqdn,
}: {
  fqdn: string,
}): React.MixedElement {
  const { __ } = useTranslator();
  return (
    <UnavailableErrorContainer
      info={__('Something seems broken right now.')}
      fqdn={fqdn}
    />
  );
};
